// Event bus implementation to replace mitt
export class EventBus {
  private readonly events: Map<string, Function[]> = new Map();

  on(type: string, handler: Function) {
    if (!this.events.has(type)) {
      this.events.set(type, []);
    }
    this.events.get(type)!.push(handler);
  }

  off(type: string, handler?: Function) {
    if (!this.events.has(type)) return;

    if (handler) {
      // Remove specific handler
      const handlers = this.events.get(type)!;
      const index = handlers.indexOf(handler);
      if (index > -1) {
        handlers.splice(index, 1);
      }
    } else {
      // Remove all handlers for this type
      this.events.delete(type);
    }
  }

  emit(type: string, data?: any) {
    if (!this.events.has(type)) return;
    const handlers = this.events.get(type)!;
    handlers.forEach((handler) => handler(data));
  }
}
